// extracted by mini-css-extract-plugin
export default {"section":"AppMenuSection_section__YkzSb","title":"AppMenuSection_title__kRk1H","content":"AppMenuSection_content__FsOFc"};